"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.programFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.programFactory = Factory.Sync.makeFactory({
    created_at: Mocks.dates.date2000,
    id: Factory.each(i => uuid_1.v4()),
    name: 'Test Program',
    org_id: 26369,
    originator_id: '33',
    originator_system: 'Ngin',
    originator_type: 'LeagueInstance',
    secondary_name: 'TP',
    short_name: 'tp',
    status: 'Active',
    updated_at: Mocks.dates.date2000,
});
